
;
                (function(){
                    const Func = (function() {
                        this.isLive&&window.location.pathname.includes("challenge")&&setTimeout(function(){var e=document.querySelector(".shopify-challenge__container");console.log(e),e.scrollIntoView()},100)
                    
                    });
                    const settings = {};
                    const ID = 'ecom-uvrjmzmiv';
                    document.querySelectorAll('.ecom-uvrjmzmiv').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            